import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Message } from '../models/WebServer/message';
import { PartecipantRoles } from '../models/WebServer/partecipantRoles';
import { AppConfigService } from '../services/app.config.service';

@Pipe({
  name: 'guestChatColor'
})
export class GuestChatColorPipe implements PipeTransform {

  // Palette di 12 colori pastello molto sfumati per sfondi chat
  // Tonalità molto chiare, quasi tendenti al bianco ma distinguibili
  private static readonly CHAT_COLORS = [
    '#f5dadd',  // Rosso molto chiaro
    '#f0d3bc',  // Arancione molto chiaro
    '#fff9ce',  // Giallo molto chiaro
    '#d7e4ca',  // Verde lime molto chiaro
    '#c5d4cc',  // Verde molto chiaro
    '#cfe7e6',  // Verde acqua molto chiaro
    '#d4e9f5',  // Azzurro molto chiaro
    '#d7e8f5',  // Blu molto chiaro
    '#c2c9da',  // Indaco molto chiaro
    '#e2d8f7',  // Viola molto chiaro
    '#f8dae7',  // Rosa molto chiaro
    '#e7d2f0',  // Magenta molto chiaro
  ];

  constructor(protected sanitizer: DomSanitizer, private config: AppConfigService) { }

  public transform(m: Message | undefined): string | null {
    // Non applicare colori multicolor se:
    // - messaggio non valido
    // - è PrimaryClient o SecondaryClient (mantengono i loro colori fissi dal CSS)
    // - chatMulticolor è disabilitato
    if (!m ||
        m.role == PartecipantRoles.PrimaryClient ||
        m.role == PartecipantRoles.SecondaryClient ||
        !this.config.agencySettings?.chatMulticolor) {
      return null;
    }

    // Usa idx del partecipante per selezionare il colore dalla palette
    // Se idx supera la palette, usa modulo per ciclare i colori
    const colorIndex = m.idx % GuestChatColorPipe.CHAT_COLORS.length;
    return GuestChatColorPipe.CHAT_COLORS[colorIndex];
  }
}
